// extracted by mini-css-extract-plugin
export default {"logoBar":"LogoHeader_logoBar__Warct","logo":"LogoHeader_logo__ZdblS","fontlogo":"LogoHeader_fontlogo__3ANbs"};